import { InterpolateService } from '@ispm/shared/services/interpolate.service';

export class  TitleItem {
 text: string;
 link?: string;
 type: 'link' | 'text';

 constructor(text: string)
 constructor(text: string, link: string);
 constructor(text: string, link: string, interpolateData: any);
 constructor(text: string, link?: string, interpolateData?: any) {
   this.text = text;
   this.link = link;
   this.type = !this.link ? 'text' : 'link';
   if (interpolateData) {
     this.interpolateText(interpolateData);
     this.interpolateLink(interpolateData);
   }
 }


 interpolateLink(data) {
   if (this.link && InterpolateService.hasInterpolationString(this.link)) {
     this.link = InterpolateService.interpolate(this.link, data);
   }
 }

 interpolateText(data) {
   if (InterpolateService.hasInterpolationString(this.text)) {
     this.text = InterpolateService.interpolate(this.text, data, false, { usePartialPath: false, clearUnresolvedPatterns: true});
   }
 }


}
